module.exports = __webpack_public_path__ + "img/experienced.42748579.svg";